// src/app/services/task-stats.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, delay, map, of } from 'rxjs';
import { TaskStatsResponse } from '@app/lib/models/task-stats.model';
import { BaseHttpService } from '@app/lib/services/base-http.service';
import { AppConfiguration } from '@app/lib/services/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class TaskStatsService extends BaseHttpService {

  private baseUrl:string;
    constructor(http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
        this.baseUrl = this.appConfig.hostUrl;
    }


    fetchStats() {
        return this.get<TaskStatsResponse>('monitor/tasks-count.htm');
    }
  }